/** Number of digits in the end-to-end security code (PIN). */
export const SECURITY_CODE_LENGTH = 6;

/** Exactly `SECURITY_CODE_LENGTH` decimal digits, full string. */
export const SECURITY_CODE_DIGITS_PATTERN = new RegExp(`^\\d{${SECURITY_CODE_LENGTH}}$`);
